import { hourNumberByTime } from '../../../utils/helpers'
import useOfficeHour from '../../services/useOfficeHour'
import { isSuccessful } from '../../useQuery'

const hoursFormatter = hour => (hour > 1 ? `${hour} horas` : `${hour} hora`)

const useOfficeHourDetail = institutionId => {
  const { getOfficeHour } = useOfficeHour(institutionId)
  const { data: officeHour, status } = getOfficeHour()

  if (!isSuccessful(status))
    return {
      receptionDeskEndOfficeHour: '-',
      receptionDeskStartOfficeHour: '-',
      receptionDeskAdditionalConfig: '-',
      otherFormsEndOfficeHour: '-',
      otherFormsStartOfficeHour: '-',
      otherFormsAdditionalConfig: '-',
      otherFormsEnabled: false,
      receptionDeskTotalHours: 0,
      otherTotalHours: 0,
      otherHoursShowWarning: false,
      status
    }

  const {
    reception_desk_end_office_hour: receptionDeskEndOfficeHour,
    reception_desk_start_office_hour: receptionDeskStartOfficeHour,
    reception_desk_additional_config: receptionDeskAdditionalConfig,
    other_forms_end_office_hour: otherFormsEndOfficeHour,
    other_forms_start_office_hour: otherFormsStartOfficeHour,
    other_forms_additional_config: otherFormsAdditionalConfig,
    other_forms_enabled: otherFormsEnabled
  } = officeHour

  const receptionDeskHours =
    hourNumberByTime(receptionDeskEndOfficeHour) - hourNumberByTime(receptionDeskStartOfficeHour)

  const otherHours =
    otherFormsEnabled && otherFormsEndOfficeHour && otherFormsStartOfficeHour
      ? hourNumberByTime(otherFormsEndOfficeHour) - hourNumberByTime(otherFormsStartOfficeHour)
      : 0

  const otherHoursShowWarning = otherHours > 0 && otherHours < 8

  return {
    receptionDeskEndOfficeHour,
    receptionDeskStartOfficeHour,
    receptionDeskAdditionalConfig,
    otherFormsEndOfficeHour: otherHours ? otherFormsEndOfficeHour : '-',
    otherFormsStartOfficeHour: otherHours ? otherFormsStartOfficeHour : '-',
    otherFormsAdditionalConfig,
    otherFormsEnabled,
    receptionDeskTotalHours: hoursFormatter(receptionDeskHours),
    otherTotalHours: otherHours ? hoursFormatter(otherHours) : '-',
    otherHoursShowWarning,
    status
  }
}

export default useOfficeHourDetail
